import { render, staticRenderFns } from "./QmsRequirementProposal.vue?vue&type=template&id=b9e75ab6&scoped=true&"
import script from "./QmsRequirementProposal.vue?vue&type=script&lang=ts&"
export * from "./QmsRequirementProposal.vue?vue&type=script&lang=ts&"
import style0 from "./QmsRequirementProposal.vue?vue&type=style&index=0&id=b9e75ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e75ab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
